// In-memory store для резерва когда localStorage не доступен
const inMemoryStorage = new Map<string, string>();

export const safeLocalStorage = {
  getItem(key: string): string | null {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(key);
      }
    } catch (error) {
      console.warn(
        'localStorage is not available, falling back to in-memory storage.'
      );
    }
    return inMemoryStorage.get(key) || null;
  },
  setItem(key: string, value: string) {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(key, value);
        return;
      }
    } catch (error) {
      console.warn(
        'localStorage is not available, falling back to in-memory storage.'
      );
    }
    inMemoryStorage.set(key, value);
  },
  removeItem(key: string) {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem(key);
        return;
      }
    } catch (error) {
      console.warn(
        'localStorage is not available, falling back to in-memory storage.'
      );
    }
    inMemoryStorage.delete(key);
  },
};
